import type { Instruction } from './commands';
import type { Rng } from './rng';

/** Swap one digit so a wrong readback also changes what the aircraft flies. */
export function garbleReadback(instruction: Instruction, rng: Rng): Instruction {
  switch (instruction.kind) {
    case 'heading': return { ...instruction, headingDeg: ((instruction.headingDeg + rng.pick([10, -10, 20, -20]) + 359) % 360) + 1 };
    case 'altitude': return { ...instruction, altitudeFt: Math.max(1000, instruction.altitudeFt + rng.pick([1000, -1000])) };
    case 'speed': return { ...instruction, speedKt: instruction.speedKt + rng.pick([10, -10]) };
    default: return instruction;
  }
}
